import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Card,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loading from "../../components/loading/Loading";
import { Constants } from "../../Constants";
import {
  deleteBanner,
  fetchBanners,
  imageUpload,
  postBanner,
} from "../../services/BannersServices";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router";

export default function Banners() {
  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [banners, setBanners] = useState([]);
  const history = useHistory();

  useEffect(() => {
    fetch();
  }, []);

  const handleFiles = async (event: any) => {
    for (let file of event.target.files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "banners",
        });
        setImage(response.data.data.image);
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchBanners({
        token: "",
      });
      setBanners(response.data.data);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await postBanner({
        token: "",
        image,
        enlace: link,
      });
      setLoading(false);
      setImage("");
      setLink("");
      fetch();
      toast(`Banner generado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const remove = async (id: number) => {
    setLoading(true);
    try {
      let response = await deleteBanner({
        token: "",
        id,
      });
      setLoading(false);
      fetch();
      toast(`Banner eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs
          title="Listado de banners"
          breadcrumbItem="Listado de banners"
        />
        <FormGroup row>
          <Label className="col-md-2 col-form-label">Enlace</Label>
          <Col md={10} style={{ zIndex: 9 }}>
            <Input value={link} onChange={(e) => setLink(e.target.value)} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label
            htmlFor="example-datetime-local-input"
            className="col-md-2 col-form-label"
          >
            Imagen
          </Label>
          <Col md={10}>
            <div className="custom-file">
              <CustomInput
                id="file"
                type="file"
                name="file"
                className="custom-file-input"
                onChange={handleFiles}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          </Col>
        </FormGroup>
        {image !== "" && (
          <FormGroup row style={{ marginBottom: "0.5rem" }}>
            <Col md={2} />
            <Col md={10}>
              <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <img
                        data-dz-thumbnail=""
                        height="80"
                        className="avatar-sm rounded bg-light"
                        style={{ width: "auto", height: "70px" }}
                        src={`${Constants.BASE_URL}${image}`}
                      />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </FormGroup>
        )}
        <FormGroup row>
          <Col md={12} className="text-right">
            <Button
              type="submit"
              color="primary"
              className="ml-2"
              onClick={() => save()}
            >
              Crear banner
            </Button>
          </Col>
        </FormGroup>

        <div className="banners">
          <div className="row">
            <div className="col-12">
              <h4>Listado de banners</h4>
            </div>
          </div>
          <div className="row">
            {banners.map((item: any) => (
              <div className="col-3 item mb-2">
                <button
                  style={{
                    position: "absolute",
                    right: "0",
                    background: "black",
                    color: "white",
                    border: "none",
                    borderRadius: "100%",
                  }}
                  onClick={() => remove(item.id)}
                >
                  X
                </button>
                <img
                  src={`${Constants.BASE_URL}${item.image}`}
                  style={{ width: "100%" }}
                />
                <div className="delete-banner" onClick={() => {}}>
                  <i className="ri-close-circle-line"></i>
                </div>
                <div className="remate-name">
                  <span>Enlace: {item.enlace}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}
